export default __webpack_public_path__ + "static/media/Frame 59.51e5b5f2.svg";